import axios from "../../../axios";

export function fetchProductDescription(category: any, id: any) {
  const data: any = id ? { anonymous_id: id } : "";
  const response = axios.post(`products/product/${category}/`, data);
  return response;
}

export function addReview(productId: any, payload: any) {
  let response = axios.post(`products/product/${productId}/review/`, payload);
  return response;
}
export function editReview(productId: any, payload: any) {
  let response = axios.put(`products/review/${productId}/`, payload);
  return response;
}

export function removeReview(reviewId: any) {
  const response = axios.delete(`products/review/${reviewId}/delete/`);
  return response;
}
